import type { AnchorHTMLAttributes } from "react";

/**
 * Stands in for `next/link`. The apps on this kit route by hash sections inside
 * one document (vinext has no client router), so a link is a plain anchor with
 * the same props the kit passes.
 */
type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

const Link = ({ href, ...props }: LinkProps) => <a href={href} {...props} />;

export default Link;
